import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { ContentService } from '@app/content/services';
import { Page } from '@app/content/models';

export type Content = Page;

export const contentResolver: ResolveFn<Content> = (route: ActivatedRouteSnapshot) => {
  return inject(ContentService).fetchContent<Content>(route.data?.['slug'] || route.url);
};